import React from 'react'

function submitted() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="bg-blue-500 text-white text-lg font-semibold py-2 px-6 rounded-full">
        Thank You for submitting!!
      </div>
    </div>  )
}

export default submitted